<template>
	<div :class="{ 'has-crossprice': hasCrossPrice }">
		<div class="crossprice" v-if="showCrossPrice && hasCrossPrice" :class="{ 'is-special-offer': hasSpecialOffer }">
			<del class="small text-appearance">
                <template v-if="hasSpecialOffer">
                    {{ currentVariation.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                </template>
                <template v-else>
                    {{ currentVariation.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                </template>
			</del>
		</div>

		<span class="price h1" :class="{ 'is-special-offer': hasSpecialOffer }">
			<span>
				<template v-if="showDynamicPrice">
					{{
						$translate("Ceres::Template.dynamicVariationPrice", {
							price: $options.filters.currency(
								variationTotalPrice,
								currentVariation.prices.default.currency
							)
						})
					}}
				</template>

				<template v-else>
					<span :content="currentVariation.prices.default.price.value">
						<div class="priceBig">{{ priceBig }}</div>
						<div class="priceRegular">{{ priceRegular }}</div>
					</span>
					<span class="currency" :content="currentVariation.prices.default.currency">{{
						currentVariation.prices.default.currency
					}}</span>
				</template>
			</span>
		</span>
		<span class="vat small text-muted">
			<template v-if="showNetPrices">
				{{ $translate("Ceres::Template.singleItemExclVAT") }}
			</template>
			<template v-else>
				{{ $translate("Ceres::Template.singleItemInclVAT") }}
			</template>
			{{ $translate("Ceres::Template.singleItemExclusive") }}
			<a
				:data-toggle="shippingCostsCategoryIdIsSet ? 'modal' : ''"
				:href="shippingCostsCategoryIdIsSet ? '#shippingscosts' : ''"
				:title="$translate('Ceres::Template.singleItemShippingCosts')"
			>
				{{ $translate("Ceres::Template.singleItemShippingCosts") }}
			</a>
		</span>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "item-price",

	props: {
		showCrossPrice: {
			type: Boolean,
			default: true
		}
	},

	inject: {
		itemId: {
			default: null
		}
	},

	computed: {
		currentVariation() {
			return this.$store.getters[`${this.itemId}/currentItemVariation`];
		},

        hasCrossPrice() {
            const hasRrpPrice = !!this.currentVariation.prices.rrp &&
                this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value;

            const hasBeforePrice = this.hasSpecialOffer &&
                !!this.currentVariation.prices.default &&
                this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },

        hasSpecialOffer() {
            return !!this.currentVariation.prices.specialOffer;
        },
		variationGraduatedPrice() {
			return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
		},

		variationTotalPrice() {
			return this.$store.getters[`${this.itemId}/variationTotalPrice`];
		},

		showDynamicPrice() {
			const state = this.$store.state.items[this.itemId];
			return (
				App.config.item.showPleaseSelect &&
				App.isCheapestSorting &&
				state.variationSelect &&
				!state.variationSelect.isVariationSelected &&
				(state.pleaseSelectVariationId === this.currentVariation.variation.id ||
					state.pleaseSelectVariationId === 0)
			);
		},

		shippingCostsCategoryIdIsSet() {
			return (App.config.global.shippingCostsCategoryId || 0) > 0;
		},

		priceBig() {
			let stringsplit = this.variationTotalPrice.toString();

			return stringsplit.split(".")[0];
		},

		priceRegular() {
			let stringsplit = this.variationTotalPrice.toString().split(".");

			if (stringsplit.length > 1) {
				if (stringsplit[1].length == 1) {
					stringsplit = stringsplit[1] + "0";
				} else {
					stringsplit = Math.round(parseFloat("0." + stringsplit[1]) * 100);
				}
			} else {
				stringsplit = this.variationTotalPrice.toString().split(",");
				if (stringsplit.length > 1) {
					if (stringsplit[1].length == 1) {
						stringsplit = stringsplit[1] + "0";
					} else {
						stringsplit = Math.round(parseFloat("0." + stringsplit[1]) * 100);
					}
				} else {
					stringsplit = "00";
				}
			}

			let separator = this.currentVariation.prices.default.currency === "EUR" ? "," : ".";

			return separator + stringsplit;
		},

		...mapState({
			showNetPrices: (state) => state.basket.showNetPrices
		})
	}
};
</script>
